// Angular
import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild, Output } from '@angular/core'
import { MatPaginator } from '@angular/material'
import { ActivatedRoute, Router } from '@angular/router'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
// Services
import { PanierLine } from '../../../../../Interfaces/Panier'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { InstructionService } from '../../../../../services/WebService/instruction.service'

import { LayoutConfigService } from '../../../../../core/_base/layout'
import { AppService, ConsultationService, ParameterService, StateService } from '../../../../../services'

const KEY = 'DASHBOARD'

@Component({
    selector: 'atyl-dashboard-tab-zone',
    templateUrl: './dashboard-tab-zone.component.html',
    styleUrls: ['dashboard-tab-zone.component.scss'],
})
@Stringable({
    path: 'views/pages/dashboard/dashboard',
    key: KEY,
})
export class DashboardTabZoneComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
    
    @StringableValues(KEY)
    strings: any
    
    inited = new EventEmitter<any>();
    
    //@Output() lengthInstru :number = 0;
    @Output() lengthSuiviInstru: EventEmitter<number> = new EventEmitter<number>();
    @Output() rowClicked: EventEmitter<any> = new EventEmitter<any>();
    
    loadingSuiviInstru: any = true;
    
    columnsSuiviInstruction: any = [];
    dataSuiviInstruction: any = [];
    PaginationSuiviInstruction: number = 10;
    currentPageSuiviInstruction: number = 0;
    loadingSuiviInstruction: boolean = false;
    sortSuiviInstruction: any
    lengthSuiviInstruLength: number = 0;
    
    listObservable: any[] = [];
    zoneTypes:any=[];
    zoneInput:string='';
    metierInput:boolean=true;

    disabledPanier:boolean=true;
	selectable:PanierLine[]=[];
    origine:any='tab-zone';
    
    constructor(

        private layoutConfigService: LayoutConfigService,
        private parameterService: ParameterService,
        private stateService: StateService,
        private router: Router,
        private appService: AppService,
        private changeDetectorRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private consultationService: ConsultationService,
        private instructionService:InstructionService
    ) {
    }

    
    ngOnInit(): void {

        console.log('dashboard tab encours', this.strings)

        this.getDataPageSuiviInsctrution(this.currentPageSuiviInstruction,true,true);
        this.stateService.zoneTypes.subscribe((res) => {
                this.zoneTypes = res;
        });
        this.listObservable.push(this.stateService.zoneTypes.subscribe((zoneType) => {
            if(!zoneType){
                this.parameterService.getZoneTypes().subscribe((zoneType) => {
                    this.stateService.updateZoneTypes(zoneType.result);
                })
            }
        }));
    }

    ngOnDestroy() {

    }

    ngAfterViewInit() {

       this.getDataPageSuiviInsctrution(this.currentPageSuiviInstruction,true);
    }

    getInitedEmitter() {

        return this.inited;
    }
    
    /*
   TABLE OF Suivi INSTRUCTOPN
*/
    onZoneChange(event:any) {

        this.getDataPageSuiviInsctrution(this.currentPageSuiviInstruction);
    }

    getDataPageSuiviInsctrution(page: number = 0, init: boolean = false, nodata: boolean = false) {

        let _options={
            page:page,
            sorts: [this.sortSuiviInstruction],
            filters: {
                zone: {value:this.zoneInput},
                metier : {value:this.metierInput}
            }
        };

        this.loadingSuiviInstruction = true
        this.appService.getList('SUIVIINSTRUCTION', _options, nodata)
            .subscribe(list => {
                //  this.loadingNotif = false;
                this.columnsSuiviInstruction = list.result.columns
                this.dataSuiviInstruction = list.result.datas.datas
                if (list.result.datas.meta) {
	
                    console.log("SUIVIINSTRUCTION meta",list.result.datas.meta);
                
                    this.lengthSuiviInstru.emit(list.result.datas.meta.total)
                    this.lengthSuiviInstruLength=list.result.datas.meta.total;
                    this.PaginationSuiviInstruction = list.result.datas.meta.perpage
                    this.currentPageSuiviInstruction = list.result.datas.meta.page
                }

                this.loadingSuiviInstru = false
                this.loadingSuiviInstruction = false
                this.inited.emit(list.result)
                this.changeDetectorRef.detectChanges()
            })
    }
    onPagedSuiviInstruction(table: any) {

        this.getDataPageSuiviInsctrution(table.currentPage)
    }
    onRowClickedSuiviInstruction(row: any) {

        let clickRow={
            row: row,
            origin: 'suiviinstruction'
        }
        this.rowClicked.emit(clickRow);
    }

    onHeaderClickedSuiviInstruction(sort: any) {

        this.sortSuiviInstruction = {
            id: sort.active,
            direction: sort.direction.toUpperCase()
        }
        this.getDataPageSuiviInsctrution(this.currentPageSuiviInstruction)
    }
    
    selectChanged(event) {

		console.log("RechercheResultComponent selectChanged", event);

		this.disabledPanier=true;
		this.selectable = []
		let _options ={
			demande: false
		}
		let oo:any[]=Object.keys(event);
		let cpt:number=0;

		Object.keys(event).forEach(key => {			
			this.instructionService.get(key,_options).subscribe(
				(res: JSONRpcResponse) => {
					if (res.result && res.result.type) {
						let r:PanierLine=new PanierLine();                        
                        if (res.result.demande!=undefined)
                            if(res.result.demande.dossier!=undefined)
                                r.dossier=res.result.demande.dossier;
                        if (res.result.type!=undefined){
                            r.instruction=res.result.type;
					    this.selectable.push(r);                        
					    cpt++;
					    if (cpt==oo.length)
					   		this.disabledPanier=false;
					   		
					    this.changeDetectorRef.detectChanges();
				    }
                }
			})
		});
	}
}
